import { Loc, t } from "@/locales";
import { FieldLabel } from "./FieldLabel";

type Props = {
  value: number;
  onChange: (value: number) => void;
};

const MIN_QUANTITY = 1;

export function QuantityInput(props: Props) {
  const canDecrease = props.value > MIN_QUANTITY;

  return (
    <div className="quantity-input">
      <FieldLabel>{t(Loc.quantityLabel)}</FieldLabel>
      <div className="quantity-input__control">
        <button
          type="button"
          className="quantity-input__step quantity-input__step--decrease"
          onClick={() => props.onChange(props.value - 1)}
          disabled={!canDecrease}
          aria-label={t(Loc.quantityDecrease)}
        >
          <svg
            className="quantity-input__icon"
            viewBox="0 0 10 10"
            aria-hidden="true"
          >
            <path
              className="quantity-input__icon-stroke"
              d="M1 5h8"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <div className="quantity-input__value">{props.value}</div>
        <button
          type="button"
          className="quantity-input__step quantity-input__step--increase"
          onClick={() => props.onChange(props.value + 1)}
          aria-label={t(Loc.quantityIncrease)}
        >
          <svg
            className="quantity-input__icon"
            viewBox="0 0 10 10"
            aria-hidden="true"
          >
            <path
              className="quantity-input__icon-stroke"
              d="M5 1v8M1 5h8"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
